import typeList from './type-list'

export default class FormItem {
  constructor (elem) {
    this.elem = elem // 要素そのもの
    this.types = this.getTypes(elem) // バリデーションタイプ
    this.messages = [] // エラーメッセージ

    this.createMessageElem()
    this.messageElem = elem.parentNode.querySelector('.form-error')
  }

  createMessageElem () {
    const newElem = document.createElement('div')
    newElem.classList.add('form-error')
    this.elem.parentNode.insertBefore(newElem, null)
  }

  // 要素がどのタイプに属するか
  getTypes (item) {
    const types = []
    const typeKeys = Object.keys(typeList)

    typeKeys.forEach(type => {
      if (item.classList.contains('input-' + type)) {
        types.unshift(type)
      }
    })
    return types
  }

  validate () {
    this.messages = []
    this.types.forEach(type => {
      const value = typeList[type].format !== undefined ? typeList[type].format(this.elem.value) : this.elem.value
      this.elem.value = value
      const validation = typeList[type].validate(value)

      if (!validation) {
        const priority = typeList[type].priority
        this.messages[priority] = typeList[type].message
        // 配列から空要素を削除
        this.messages = this.messages.filter(Boolean)
      }
    })
    this.showMessage()
  }

  showMessage () {
    if (this.messages.length > 0) {
      this.messageElem.innerText = this.messages[0]
    } else {
      this.messageElem.innerText = ''
    }
  }

  errorNum () {
    return this.messages.length
  }
}
